module.exports = __webpack_public_path__ + "static/media/Menu.4b566bcf.svg";